export default __webpack_public_path__ + "static/media/sms-campaign-3.744f4596.png";